import { svg } from "uhtml";

export function closeIcon() {
  return svg`<svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" class="jb-close-icon icon" role="img" aria-labelledby="close-icon">
  <use xlink:href="#close-icon"></use>
</svg>`;
}
